import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  {label: 'Empresa Privada', value: 'private_company'},
  {label: 'Empresa Pública', value: 'public_company'},
  {label: 'Estabelecimento', value: 'establishment'},
]

export const strategy = optionsToStrategy(options)